import styled from "styled-components";
import { Grid, TextField } from "@material-ui/core";

export const STGrid = styled(Grid)`
  && {
    padding-top: 8px;
  }
`;

export const STApplicationWrapper = styled.div`
  && {
    display: flex;
    padding-top: 8px;
  }
`;

export const STLocationTextField = styled(TextField)`
  && {
    padding-right: 8px;
    width: 40%;
  }
`;

export const STUrlTextField = styled(TextField)`
  && {
    width: 60%;
  }
`;

export const STApplicationsWrapper = styled.div`
  && {
    overflow-y: auto;
    max-height: 200px;
  }
`;

export const STError = styled(Grid)`
   {
    && {
      font-size: 0.8rem;
      color: #f44336;
      min-height: 1em;
      line-height: 1em;
      text-align: left;
      font-weight: 400;
      padding-right: 16px;
      padding-top: 8px;
    }
  }
`;
